// import React from 'react';
// import { Container, Row, Col } from 'react-bootstrap';

// const PrivacyPolicy = () => {
//   return (
//     <Container className="my-5">
//       <h1 className="mb-4">Privacy Policy</h1>
//       <Row>
//         <Col>
//           <p>At OlewinAcademy, we are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information.</p>
          
//           <h3>1. Information We Collect</h3>
//           <p>We collect personal information when you sign up, such as:</p>
//           <ul>
//             <li>Name</li>
//             <li>Email address</li>
//             <li>Phone number</li>
//             <li>Company/Organization</li>
//           </ul>
          
//           <h3>2. How We Use Your Information</h3>
//           <p>We use your information to:</p>
//           <ul>
//             <li>Provide educational services.</li>
//             <li>Send you updates and newsletters related to our services.</li>
//             <li>Improve our services based on feedback.</li>
//           </ul>

//           <h3>3. Sharing of Information</h3>
//           <p>We do not share your personal information with third parties except:</p>
//           <ul>
//             <li>When required by law.</li>
//             <li>With your consent to share information with trusted partners.</li>
//           </ul>

//           <h3>4. Data Security</h3>
//           <p>
//             We take appropriate security measures to protect your personal information from unauthorized access, alteration, or disclosure.
//           </p>

//           <h3>5. Cookies</h3>
//           <p>
//             Our website uses cookies to improve your experience. You can opt-out of cookies by adjusting your browser settings.
//           </p>

//           <h3>6. Third-Party Links</h3>
//           <p>
//             Our services may include links to third-party websites. We are not responsible for the privacy practices or content of these websites.
//           </p>

//           <h3>7. Your Rights</h3>
//           <p>You have the right to:</p>
//           <ul>
//             <li>Request access to your personal information.</li>
//             <li>Request corrections to your information.</li>
//             <li>Request deletion of your personal data.</li>
//           </ul>

//           <h3>8. Changes to This Policy</h3>
//           <p>We may update this privacy policy periodically. Any changes will be posted on this page.</p>

//           <h3>9. Contact Us</h3>
//           <p>If you have any questions or concerns about this Privacy Policy, please contact us at info@olewinacademy.com.</p>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default PrivacyPolicy;


import React from 'react';
import { Lock, Shield, Eye, Database, UserCheck, AlertTriangle } from 'lucide-react';

const PrivacyPolicy = () => {
  const sections = [
    {
      id: 'introduction',
      title: '1. Introduction',
      icon: Shield,
      content: `Olewin Academy ("we", "us", "our") is committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services, website, mobile applications, or enroll in our courses.

We respect your privacy rights and are committed to complying with applicable data protection laws including the Information Technology Act, 2000 and Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011.

By using our services, you consent to the data practices described in this policy. If you do not agree with this policy, please do not use our services.`
    },
    {
      id: 'collection',
      title: '2. Information We Collect',
      icon: Database,
      content: `2.1 Personal Information:
• Name, date of birth, gender
• Email address and phone number
• Residential address
• Parent/guardian contact information (for minors)
• Government ID proof (Aadhar, Passport, etc.)
• Educational qualifications and academic records
• Photographs (for ID cards and certificates)

2.2 Payment Information:
• Credit/debit card details (processed by secure payment gateways)
• Bank account information
• Transaction history
• Billing address

2.3 Academic Information:
• Course enrollment details
• Attendance records
• Test scores and performance data
• Assignments and project submissions
• Study progress and analytics
• Feedback and evaluations

2.4 Technical Information:
• IP address and device information
• Browser type and version
• Operating system
• Login times and session duration
• Pages visited and features used
• Cookies and tracking technologies

2.5 Communication Data:
• Email correspondence
• Support tickets and queries
• Chat messages
• Forum posts and comments
• Survey responses

2.6 Automatically Collected Information:
We use cookies, web beacons, and similar technologies to automatically collect usage information, preferences, and device data to improve your experience.`
    },
    {
      id: 'usage',
      title: '3. How We Use Your Information',
      icon: UserCheck,
      content: `We use collected information for the following purposes:

3.1 Service Delivery:
• Providing educational services and course content
• Managing enrollments and student accounts
• Processing payments and issuing receipts
• Delivering study materials and resources
• Conducting classes and assessments
• Tracking academic progress
• Issuing certificates and credentials

3.2 Communication:
• Sending course updates and announcements
• Providing customer support
• Responding to inquiries and requests
• Sending administrative information
• Marketing communications (with opt-out option)

3.3 Improvement and Analytics:
• Analyzing usage patterns and trends
• Improving course content and teaching methods
• Developing new features and services
• Conducting research and analytics
• Personalizing user experience

3.4 Legal and Safety:
• Complying with legal obligations
• Enforcing our terms and policies
• Protecting against fraud and security threats
• Resolving disputes
• Protecting rights and safety of users

3.5 Marketing and Promotional:
• Sending promotional offers and discounts
• Informing about new courses and programs
• Conducting surveys and gathering feedback
• Remarketing and advertising campaigns

You can opt-out of marketing communications at any time by clicking the unsubscribe link in emails or contacting us.`
    },
    {
      id: 'sharing',
      title: '4. Information Sharing and Disclosure',
      icon: Eye,
      content: `4.1 We Do NOT Sell Personal Information:
We do not sell, rent, or trade your personal information to third parties for their marketing purposes.

4.2 Service Providers:
We share information with trusted third-party service providers who assist us in:
• Payment processing (payment gateways)
• Cloud hosting and data storage
• Email delivery services
• Analytics and performance monitoring
• Customer support tools
• Marketing platforms

These providers are bound by confidentiality obligations and can only use information for specified purposes.

4.3 Educational Partners:
We may share information with:
• Guest lecturers and visiting faculty
• Partner institutions for collaborative programs
• Examination authorities (when required)
• Placement and recruitment partners (with consent)

4.4 Legal Requirements:
We may disclose information when required by law:
• Court orders or legal processes
• Government authorities and regulators
• Law enforcement agencies
• Protection of our legal rights
• Prevention of fraud or illegal activities

4.5 Business Transfers:
In case of merger, acquisition, or sale of assets, your information may be transferred to the acquiring entity.

4.6 With Your Consent:
We may share information for purposes not listed here with your explicit consent.

4.7 Aggregate Information:
We may share anonymized, aggregated data that cannot identify you personally for research, marketing, or analytical purposes.`
    },
    {
      id: 'security',
      title: '5. Data Security',
      icon: Lock,
      content: `5.1 Security Measures:
We implement industry-standard security measures including:
• SSL/TLS encryption for data transmission
• Encrypted storage of sensitive information
• Regular security audits and vulnerability assessments
• Access controls and authentication mechanisms
• Firewalls and intrusion detection systems
• Regular data backups
• Employee confidentiality agreements

5.2 Payment Security:
Payment information is processed by PCI-DSS compliant payment gateways. We do not store complete credit card details on our servers.

5.3 Account Security:
You are responsible for:
• Maintaining confidentiality of login credentials
• Using strong passwords
• Not sharing account access
• Logging out after sessions
• Reporting unauthorized access immediately

5.4 Limitations:
While we implement reasonable security measures, no system is completely secure. We cannot guarantee absolute security of your information. You use our services at your own risk.

5.5 Data Breach Notification:
In the event of a data breach affecting your personal information, we will notify you as required by applicable laws.`
    },
    {
      id: 'retention',
      title: '6. Data Retention',
      icon: Database,
      content: `6.1 Retention Period:
We retain your information for as long as necessary to:
• Provide services during active enrollment
• Maintain academic records (minimum 7 years)
• Comply with legal obligations
• Resolve disputes and enforce agreements
• Support alumni services

6.2 Active Students:
Data is retained throughout enrollment period and for reasonable period after course completion for alumni services.

6.3 Inactive Accounts:
Accounts inactive for 3 years may be deleted after notification, except where legal retention is required.

6.4 Academic Records:
Academic records including certificates, test scores, and attendance are retained indefinitely for verification purposes.

6.5 Deletion Requests:
You can request deletion of your personal information subject to our legal retention obligations. Some data may need to be retained for legal, regulatory, or legitimate business purposes.`
    },
    {
      id: 'rights',
      title: '7. Your Privacy Rights',
      icon: UserCheck,
      content: `You have the following rights regarding your personal information:

7.1 Access and Portability:
• Right to access your personal information
• Right to obtain a copy of your data
• Right to data portability

7.2 Correction and Update:
• Right to correct inaccurate information
• Right to update outdated information
• Right to complete incomplete information

7.3 Deletion:
• Right to request deletion of your information (subject to retention requirements)
• Right to be forgotten (where applicable)

7.4 Restriction and Objection:
• Right to restrict processing of your information
• Right to object to certain processing activities
• Right to opt-out of marketing communications

7.5 Consent Withdrawal:
• Right to withdraw consent for data processing (may affect service availability)

7.6 Lodge Complaints:
• Right to file complaints with data protection authorities

To exercise these rights, contact us at privacy@olewinacademy.com. We will respond within 30 days of receiving your request.`
    },
    {
      id: 'cookies',
      title: '8. Cookies and Tracking Technologies',
      icon: Eye,
      content: `8.1 What Are Cookies:
Cookies are small text files stored on your device that help us provide and improve our services.

8.2 Types of Cookies We Use:
• Essential Cookies: Required for basic website functionality
• Analytics Cookies: Help understand usage patterns
• Preference Cookies: Remember your settings and preferences
• Marketing Cookies: Used for targeted advertising

8.3 Third-Party Cookies:
We use third-party services (Google Analytics, Facebook Pixel, etc.) that may set their own cookies.

8.4 Cookie Management:
You can control cookies through browser settings. Note that blocking cookies may affect functionality.

8.5 Do Not Track:
We currently do not respond to Do Not Track browser signals.`
    },
    {
      id: 'children',
      title: '9. Children\'s Privacy',
      icon: AlertTriangle,
      content: `9.1 Age Requirements:
Our services are primarily for students aged 13 and above. Students under 18 require parental/guardian consent for enrollment.

9.2 Parental Consent:
For students under 18:
• Parental consent is obtained during enrollment
• Parents have access to student progress reports
• Parents can request access to or deletion of child's information
• Parents receive important communications

9.3 Special Protections:
We take additional precautions to protect information of minors including limited data collection and enhanced security measures.

9.4 Parental Rights:
Parents can review, modify, or request deletion of their child's information by contacting us.`
    },
    {
      id: 'international',
      title: '10. International Data Transfers',
      icon: Database,
      content: `10.1 Data Location:
Your information is primarily stored on servers located in India. However, some service providers may process data in other countries.

10.2 Transfer Safeguards:
When transferring data internationally, we ensure appropriate safeguards including:
• Standard contractual clauses
• Privacy Shield compliance (where applicable)
• Adequate data protection measures

10.3 Consent:
By using our services, you consent to international transfer of your information as described.`
    },
    {
      id: 'thirdparty',
      title: '11. Third-Party Links and Services',
      icon: Eye,
      content: `Our website and services may contain links to third-party websites, services, or integrations:

11.1 Third-Party Privacy:
We are not responsible for privacy practices of third-party websites or services. We encourage you to review their privacy policies.

11.2 Social Media:
If you interact with our social media pages, your interactions are governed by the respective platform's privacy policies.

11.3 External Tools:
Third-party tools integrated in our services (payment gateways, video conferencing, etc.) have their own privacy policies.`
    },
    {
      id: 'updates',
      title: '12. Changes to Privacy Policy',
      icon: AlertTriangle,
      content: `12.1 Policy Updates:
We reserve the right to modify this Privacy Policy at any time. Changes will be posted on our website with updated "Last Modified" date.

12.2 Material Changes:
For significant changes, we will notify you via:
• Email notification
• Website banner
• In-app notification

12.3 Continued Use:
Your continued use of services after changes constitutes acceptance of the updated policy.

12.4 Review Responsibility:
It is your responsibility to regularly review this Privacy Policy for updates.`
    },
    {
      id: 'contact',
      title: '13. Contact Information',
      icon: UserCheck,
      content: `For questions, concerns, or requests regarding this Privacy Policy or your personal information:

Privacy Officer
Olewin Academy
Email: olewinacademy@gmail.com
Phone: [+91 8639449423]
Address: [Official Address:- Olewin Group] India & USA

Response Time: We aim to respond to all privacy inquiries within 30 days.

Data Protection Officer:
[Name]
Email: olewinacademy@gmail.com

Grievance Officer (as per IT Act, 2000):
[Name]
Email: olewinacademy@gmail.com

Last Modified: October 21, 2025
Effective Date: October 21, 2025`
    }
  ];

  return (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', backgroundColor: '#fff' }}>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
        color: 'white',
        padding: '80px 20px 60px',
        textAlign: 'center',
        marginTop: "15px"
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Lock size={60} color="#58A95B" style={{ marginBottom: '20px' }} />
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 2.8rem)',
            fontWeight: 'bold',
            marginBottom: '1rem'
          }}>
            Privacy Policy
          </h1>
          <p style={{ fontSize: '1.1rem', opacity: 0.9, lineHeight: '1.6' }}>
            Your privacy is important to us. Learn how we collect, use, and protect your information.
          </p>
          <div style={{
            backgroundColor: 'rgba(88, 169, 91, 0.2)',
            border: '2px solid #58A95B',
            borderRadius: '10px',
            padding: '15px',
            marginTop: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: 'center'
          }}>
            <Shield size={24} color="#58A95B" />
            <span style={{ fontSize: '0.95rem' }}>Last Modified: October 21, 2025</span>
          </div>
        </div>
      </section>

      {/* Key Points */}
      <section style={{ padding: '40px 20px', backgroundColor: '#f8f9fa' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: '1.8rem', marginBottom: '30px', color: '#000' }}>
            Key Privacy Points
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            {[
              { icon: Lock, text: 'We do not sell your personal information' },
              { icon: Shield, text: 'Industry-standard security measures' },
              { icon: Eye, text: 'Transparent data collection practices' },
              { icon: UserCheck, text: 'You control your data and privacy rights' }
            ].map((item, idx) => {
              const IconComponent = item.icon;
              return (
                <div key={idx} style={{
                  backgroundColor: 'white',
                  padding: '20px',
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
                }}>
                  <IconComponent size={30} color="#58A95B" style={{ flexShrink: 0 }} />
                  <span style={{ color: '#333', fontWeight: '500' }}>{item.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Policy Content */}
      <section style={{ padding: '60px 20px', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {/* Table of Contents */}
          <div style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '12px',
            padding: '30px',
            marginBottom: '30px',
            border: '2px solid #58A95B'
          }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#000' }}>Table of Contents</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '10px' }}>
              {sections.map((section) => (
                <a
                  key={section.id}
                  href={`#${section.id}`}
                  style={{
                    color: '#58A95B',
                    textDecoration: 'none',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    transition: 'all 0.3s ease',
                    display: 'block',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'white';
                    e.target.style.paddingLeft = '20px';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.paddingLeft = '12px';
                  }}
                >
                  {section.title}
                </a>
              ))}
            </div>
          </div>

          {/* Sections */}
          {sections.map((section) => {
            const IconComponent = section.icon;
            return (
              <div
                key={section.id}
                id={section.id}
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '12px',
                  padding: '30px',
                  marginBottom: '20px',
                  border: '1px solid #e0e0e0',
                  scrollMarginTop: '20px'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                  <IconComponent size={30} color="#58A95B" />
                  <h2 style={{
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    color: '#000',
                    margin: 0
                  }}>
                    {section.title}
                  </h2>
                </div>
                <div style={{
                  color: '#333',
                  lineHeight: '1.8',
                  fontSize: '1rem',
                  whiteSpace: 'pre-line'
                }}>
                  {section.content}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Contact Section */}
      <section style={{
        padding: '60px 20px',
        background: 'linear-gradient(135deg, #58A95B 0%, #4a8f4d 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            Questions About Your Privacy?
          </h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', lineHeight: '1.6' }}>
            If you have any questions or concerns about how we handle your personal information, 
            our privacy team is here to help.
          </p>
          <div style={{
            backgroundColor: 'rgba(0,0,0,0.2)',
            padding: '25px',
            borderRadius: '10px',
            marginBottom: '20px'
          }}>
            <p style={{ fontSize: '1.1rem', marginBottom: '15px', fontWeight: '600' }}>
              Contact Privacy Officer
            </p>
            <p style={{ margin: '5px 0' }}>Email: olewinacademy@gmail.com</p>
            <p style={{ margin: '5px 0' }}>Phone: [+91 8639449423]</p>
            <p style={{ margin: '5px 0', fontSize: '0.9rem', opacity: 0.9 }}>
              Response Time: Within 24hrs to 3 working days
            </p>
          </div>
          <button style={{
            backgroundColor: '#000000',
            border: 'none',
            padding: '12px 35px',
            fontSize: '1rem',
            fontWeight: '600',
            borderRadius: '8px',
            color: 'white',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1a1a1a'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#000000'}> <a className='bg-black text-white' href="/contact">   Contact Privacy Team </a>
         
          </button>
        </div>
      </section>

      <style>{`
        * {
          box-sizing: border-box;
        }

        @media (max-width: 768px) {
          section {
            padding: 40px 15px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;